import React from "react";
import { LifeBuoy } from "lucide-react";
import Headerdash from "./head";
import Sidebar from "./sidebar";
import SupportTicketPanel from "./DashboardComponent/SupportTicketPanel";

const SupportShell = ({ children }) => (
  <div className="min-h-screen bg-slate-50 text-gray-700">
    <Headerdash />
    <Sidebar />
    <main className="min-h-screen pt-20 sm:pl-72">
      <div className="mx-auto w-full max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
        {children}
      </div>
    </main>
  </div>
);

export default function SupportPage() {
  return (
    <SupportShell>
      <section className="mb-6 flex flex-col gap-4 border-b border-slate-200 pb-6 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <p className="text-sm font-semibold uppercase text-purple-700">Support</p>
          <h1 className="mt-1 text-2xl font-extrabold text-gray-900 sm:text-3xl">
            Support Tickets
          </h1>
        </div>
        <span className="grid h-11 w-11 shrink-0 place-items-center rounded-md bg-purple-50 text-purple-700">
          <LifeBuoy className="h-5 w-5" aria-hidden="true" />
        </span>
      </section>

      <SupportTicketPanel />
    </SupportShell>
  );
}
